// Type alias for URL strings
type SCTAExpressionUrlId = string;

// query info block, division, or item (possible also collection)
export function basicInfoQuery(itemExpressionUri: SCTAExpressionUrlId){
  const query = [
    "SELECT DISTINCT ?title ?structureType ?cmanifestation ?cmanifestationTitle ?manifestation ?manifestationTitle ?ctranscription ?manifestationCTranscription ?manifestationCTranscriptionDoc ?cdoc ?cxml ?expressionShortId ?longTitle ?topLevelExpression ?next ?previous ?inbox ?author ?authorTitle ?parent ?manifestationLanguage ",
    "WHERE { ",
    "<" + itemExpressionUri + "> <http://purl.org/dc/elements/1.1/title> ?title .",
    "<" + itemExpressionUri + "> <http://scta.info/property/structureType> ?structureType .",
    "<" + itemExpressionUri + "> <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation .",
    "?cmanifestation <http://purl.org/dc/elements/1.1/title> ?cmanifestationTitle .",
    "<" + itemExpressionUri + "> <http://scta.info/property/hasManifestation> ?manifestation .",
    "?manifestation <http://purl.org/dc/elements/1.1/title> ?manifestationTitle .",
    "OPTIONAL {",
      "?manifestation <http://purl.org/dc/elements/1.1/language> ?manifestationLanguage .",
    "}",
    "OPTIONAL {",
    "?manifestation <http://scta.info/property/hasCanonicalTranscription> ?manifestationCTranscription .",
    "?manifestationCTranscription <http://scta.info/property/hasDocument> ?manifestationCTranscriptionDoc .",
    "?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription .",
    "?ctranscription <http://scta.info/property/hasDocument> ?cdoc . ",
    "?ctranscription <http://scta.info/property/hasXML> ?cxml . ",
    "}",
    "<" + itemExpressionUri + "> <http://scta.info/property/shortId> ?expressionShortId .",
    "{",
      "<" + itemExpressionUri + "> <http://scta.info/property/isPartOfTopLevelExpression> ?topLevelExpression .",
    "}",
    "UNION",
    "{",
      "<" + itemExpressionUri + "> <http://scta.info/property/level> '1' .",
      "BIND(<" + itemExpressionUri + "> AS ?topLevelExpression) .", 
    "}",
    "OPTIONAL {",
    "<" + itemExpressionUri + "> <http://scta.info/property/longTitle> ?longTitle .",
    "}",
    "OPTIONAL {",
    "?topLevelExpression <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
    "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
    "}",
    "OPTIONAL {",
    "<" + itemExpressionUri + "> <http://scta.info/property/next> ?next .",
    "}",
    "OPTIONAL {",
    "<" + itemExpressionUri + "> <http://scta.info/property/previous> ?previous .",
    "}",
    "OPTIONAL {",
    "<" + itemExpressionUri + "> <http://purl.org/dc/terms/isPartOf> ?parent .",
    "}",
    "<" + itemExpressionUri + "> <http://www.w3.org/ns/ldp#inbox> ?inbox . ",
    "}",
    "ORDER BY ?title"].join('');

    return query
  }